import { createFileRoute } from '@tanstack/react-router';
import { AdminReimbursementsPage } from '@/features/reimbursements/components/AdminReimbursementsPage';
import { usePermissions } from '@/common/hooks/usePermissions';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/reimbursements/admin')({
  component: AdminReimbursementsRoute,
});

function AdminReimbursementsRoute() {
  const { hasPermission } = usePermissions();
  if (!hasPermission(Permission.REIMBURSEMENTS_ADMIN)) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">
          Você não tem permissão para acessar esta página.
        </p>
      </div>
    );
  }
  return <AdminReimbursementsPage />;
}
